<template>
  <div class="add-dialog-item">
    <UIButtonIcon
      :leading="item?.icon"
      :disabled="isUnavailable"
      :label="displayLabel"
      :variant
      fill="outlined"
      size="2xl"
      class="add-dialog-item__button"
      @click="handleClick"
    />
    <UpgradePlan
      v-if="isUnavailable"
      v-tooltip="'Upgrade your plan to access the widget'"
      limit-text="Unavailable"
      class="add-dialog-item__plan"
      @click="handleClickUpgrade"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ButtonVariant } from '@types'
import { AddDialogItem } from './utils/types'

import UpgradePlan from '@/modules/UpgradePlan/UpgradePlan.vue'
import { UIButtonIcon } from '@ui/buttons'

type Props = {
  item: AddDialogItem
  variant?: ButtonVariant
}

type Emits = {
  click: [data: AddDialogItem]
  'click:upgrade': []
  upgrade: []
}

const { variant = 'gray', ...props } = defineProps<Props>()
const emit = defineEmits<Emits>()

const displayLabel = computed(() => props.item?.label)

const isUnavailable = computed(() => !!props.item.unavailable)

const handleClick = () => {
  emit('click', props.item)
}

const handleClickUpgrade = () => {
  emit('click:upgrade')
}
</script>

<style>
.add-dialog-item {
  @apply relative;

  &__plan {
    @apply absolute top-6 left-1/2 -translate-x-1/2;
    @apply whitespace-nowrap;
  }
}
</style>
